import { render, staticRenderFns } from "./VersionsModal.vue?vue&type=template&id=32441362&"
import script from "./VersionsModal.vue?vue&type=script&lang=js&"
export * from "./VersionsModal.vue?vue&type=script&lang=js&"
import style0 from "./VersionsModal.vue?vue&type=style&index=0&id=32441362&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports